import ContentHeading from '../../../components/layout/content/ContentHeading'
import { ButtonBack, ButtonDel, ButtonPrimary } from '../../../components/button/ButtonCustoms'
import InputTextField from '../../../components/input/inputTextField'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TableCustom from '../../../components/table/tableCustom';
import { useCallback, useEffect, useState } from 'react';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { useDispatch, useSelector } from 'react-redux';
import { dateToView } from '../../../utils/date.utils';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { PositionApi } from '../../../api/position/position.api';
import ModalCustom from '../../../components/modal/ModalCustom';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { swalActive, swalSuccess } from '../../../components/alert/swal';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';
import { checkPermission } from '../../../utils/app.utils';
type Props = {}

const defaultForm = {
    position_name: '',
    status: "active",
    is_approve: true
}
const ManageJobTitles = (props: Props) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();



    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('ManageJobTitles', permission);
    

    const [open, setOpen] = useState<boolean>(false);       
    const [page, setPage] = useState<number>(1);        
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(13);
    const [data, setData] = useState<any[]>([]);
    const [form, setForm] = useState<any>(defaultForm);


    const [search, setSearch] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const [isEditable, setIsEditable] = useState<boolean>(false)

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const headCells = [
        {
            id: "position_name", width: 140, sortable: true, disablePadding: false, align: 'start', label: t("MABAGA_JOB_TITLE.TABLE.NAME_COLUMN")
        },
        {
            id: "status", disablePadding: false, width: 195, sortable: true, align: "center", label: t("MABAGA_JOB_TITLE.TABLE.STATUS_COLUMN")
        },
        {
            id: "createBy", disablePadding: false, align: "center", width: 141, label: t("MABAGA_JOB_TITLE.TABLE.CREATE_BY_COLUMN")
        },
        {
            id: "createDate", disablePadding: false, align: "center", width: 257, label: t("MABAGA_JOB_TITLE.TABLE.CREATE_DATE_COLUMN")
        },
        {
            id: "action", disablePadding: false, align: "center", class: matches && data?.length > 0, width: 60, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { position_name, fullname, status, id_position, created_date, modifind_date } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "start", label: position_name || "-" },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <div className="flex justify-center">
                            <SwitchCustom
                                checked={status === 'active'}
                                onChange={(e) => handleUpdateStatus(objData, id_position)}
                            />
                        </div>

                    )
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: `${fullname.title} ${fullname.first_name} ${fullname.last_name}` || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(modifind_date || created_date) || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: (
                        <>
                            <RemoveRedEyeOutlinedIcon
                                onClick={() => {
                                    setOpen(true)
                                    setIsEditable(true)
                                    setForm({ ...objData, is_approve: objData?.is_approve ? true : false })
                                }}
                                style={{
                                    cursor: "pointer",
                                }}
                            />
                        </>
                    )
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            //   if (sortBy) condition = { ...condition, sortBy: sortBy };
            //   if (sortType) condition = { ...condition, sortType: sortType };
            if (search) condition = { ...condition, position_name: search }
            const res = await PositionApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data?.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleCreate = async () => {
        const body = {
            position_name: form.position_name,
            status: 'active',
            is_approve: form.is_approve
        };
        if (form?.id_position) {
            await PositionApi.update(body, form?.id_position).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MABAGA_JOB_TITLE.ALERT.SAVE_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => console.log(error))

        } else {
            await PositionApi.create(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MABAGA_JOB_TITLE.ALERT.CREATE_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => console.log(error))
        }
    }
    const handleClose = async () => {
        setOpen(false)
        setIsEditable(false)
        setForm(defaultForm)
    }
    const handleDelete = async () => {
        swalActive(t('MABAGA_JOB_TITLE.ALERT.DELETE_CONFIRM'), '', async () => {
            await PositionApi.delete(form?.id_position).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MABAGA_JOB_TITLE.ALERT.DELETE_SUCCESS'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => console.log(error))
        }, 'question', t('MABAGA_JOB_TITLE.COMMON.BUTTON_OK'))

    }
    const handleUpdateStatus = async (form: any, id: number) => {
        const body = {
            ...form,
            status: form?.status === 'active' ? 'inactive' : 'active',
            is_approve: form?.is_approve === 1 ? true : false
        }
        await PositionApi.update(body, id).then((res: any) => {
            if (res.status < 300) {
                loadData()
            }
        }).catch((error: any) => console.log(error))
    }

    return (
        <div>
            <ContentHeading title={"TOPIC.MANAGE_JOB_TITLES"} detail='HEADING.SELECT_LIST' />
            <div className='w-full grid grid-cols-12 gap-4 mt-[40px]'>
                <article className='w-full col-span-12 md:col-span-12 lg:col-span-4'>
                    <InputTextField
                        startAdornment={<SearchOutlinedIcon />}
                        placeholder={t('MABAGA_JOB_TITLE.SREACH_NAME')}
                        value={search}
                        onchange={(e) => setSearch(e.target.value)}
                    />
                </article>

                <article className="col-span-12 md:col-span-8 flex justify-start lg:justify-end">
                    {checkPermit.isCreated && (
                        <ButtonPrimary
                            onClick={() => setOpen(true)}
                            mode='add'
                            buttonName={t('MABAGA_JOB_TITLE.ADD_NAME')}
                        />
                    )}
                </article>
            </div>
            <section className='w-full mt-10'>
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={data?.map((data: any, i: any) => {
                        return renderData(data, i)
                    })}
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom

                title={t('MABAGA_JOB_TITLE.ADD_NAME')} subTitle={t('MABAGA_JOB_TITLE.SUBTITLE')} open={open} component={
                    <div className='flex flex-col gap-4'>
                        <div>
                            <InputTextField
                                heading={t('MABAGA_JOB_TITLE.NAME')}
                                placeholder={t('MABAGA_JOB_TITLE.SPECIFY_NAME')}
                                value={form.position_name}
                                onchange={(e) => setForm({ ...form, position_name: e.target.value })}
                                disabled={isEditable}
                            />
                        </div>
                        <div>
                            <Typography>{t('MABAGA_JOB_TITLE.APPROVAL_RIGHTS')}</Typography>
                            <CheckBoxCustom label={t('MABAGA_JOB_TITLE.RIGHT_TO_APPROVE_LEAVE_APPROVAL')} checked={form.is_approve} setChecked={(status: boolean) => { setForm({ ...form, is_approve: status }) }} disabled={isEditable}
                            />
                        </div>
                        <div className='flex justify-center gap-4'>
                            <ButtonBack
                                onClick={() => {
                                    handleClose()
                                }}
                                buttonName={t('MABAGA_JOB_TITLE.COMMON.BUTTON_CANCEL')}
                            />
                            {checkPermit.isUpdate && (
                                <>
                                    {!isEditable ? <ButtonPrimary
                                        onClick={() => handleCreate()}
                                        mode='add'
                                        disabled={!form?.position_name}
                                        buttonName={t('MABAGA_JOB_TITLE.COMMON.BUTTON_CONFIRM')}
                                    /> :
                                        <>
                                            <ButtonPrimary
                                                onClick={() => setIsEditable(false)}
                                                buttonName={t('MABAGA_JOB_TITLE.COMMON.BUTTON_EDIT')}
                                            />
                                            <ButtonDel
                                                onClick={() => { handleDelete() }}
                                                buttonName={t('MABAGA_JOB_TITLE.COMMON.BUTTON_DELETE')}
                                            />
                                        </>
                                    }
                                </>
                            )}

                        </div>
                    </div>
                } />
        </div>
    )
}

export default ManageJobTitles